import { Alert, Card, Empty, Menu, Spin } from 'antd';
import { ProLockOverlay } from 'components/global/ProLock';
import { getTabComponent, resolveIcon } from 'providers/ClientTabs/clientTabsRegistry';
import { useClientTabs } from 'providers/ClientTabs/ClientTabsProvider';
import React, { useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import ClienteHeader from 'components/admin/Clientes/ClienteHeader';

const IDClientePage = () => {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { tabs, loading, error } = useClientTabs();
  const [current, setCurrent] = useState(null);

  // Carga el tab de la URL si existe y está habilitado; si no, cae al primero.
  useEffect(() => {
    if (!tabs || tabs.length === 0) {
      setCurrent(null);
      return;
    }
    const queryParams = new URLSearchParams(location.search);
    const requested = queryParams.get('tab');
    const valid = tabs.find((t) => t.key === requested);
    setCurrent(valid ? valid.key : tabs[0].key);
  }, [tabs, location.search]);

  const menuItems = useMemo(
    () =>
      tabs.map((t) => ({
        key: t.key,
        label: t.label,
        icon: resolveIcon(t.icon),
      })),
    [tabs]
  );

  const onClick = (e) => {
    setCurrent(e.key);
    navigate(`?tab=${e.key}`);
  };

  const ActiveComponent =
    current && !loading && !error && tabs?.length ? getTabComponent(current, 'ejecutivo') : null;
  const currentTab = current ? tabs?.find((t) => t.key === current) : null;
  const isLocked = currentTab?.locked ?? false;

  // El header de identidad va SIEMPRE arriba de los tabs (independiente del
  // estado de carga de la config de tabs, que viene de DB).
  const renderTabsArea = () => {
    if (loading) {
      return (
        <div style={{ textAlign: 'center', padding: 40 }}>
          <Spin size="large" />
        </div>
      );
    }
    if (error) {
      return (
        <Alert
          type="error"
          showIcon
          message="No se pudieron cargar los tabs"
          description="Contactá al administrador si el problema persiste."
        />
      );
    }
    if (!tabs || tabs.length === 0) {
      return <Empty description="No hay tabs configurados para tu usuario en este tenant." />;
    }
    return (
      <>
        <Menu
          onClick={onClick}
          selectedKeys={current ? [current] : []}
          mode="horizontal"
          items={menuItems}
        />
        <div className="mt-2">
          {ActiveComponent ? (
            <ProLockOverlay locked={isLocked}>
              <ActiveComponent id={id} />
            </ProLockOverlay>
          ) : null}
        </div>
      </>
    );
  };

  return (
    <>
      <ClienteHeader id={id} />
      <Card>{renderTabsArea()}</Card>
    </>
  );
};

export default IDClientePage;
